// PDF React View
import UploadForm from "components/shared-components/UploadForm";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  resetUploadAttackFileInvoice,
  uploadAttackFileInvoice,
  uploadFileInvoice,
} from "store/issue-invoice/actions";
const UploadFileAttack = props => {
  const { isOpen, toggle, importHandle, idRootInvoice } = props;
  const { addToast } = useToasts();

  const [listFile, setListFile] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setListFile([]);
    }
  }, [isOpen]);

  const dispatch = useDispatch();
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { uploadFile, loadingUploadFile, type } = issueInvoice;

  // Action Dispatch
  useEffect(() => {
    if (uploadFile && uploadFile.success) {
      setListFile([...listFile, { id: uploadFile.id, file_name: "" }]);
      dispatch(resetUploadAttackFileInvoice());
    }
  }, [uploadFile]);

  const handleFiles = (files, uploadType = "") => {
    setListFile([]);
    if (files.length > 0) {
      for (const item of files) {
        const bodyFormData = new FormData();
        bodyFormData.append("file", item);
        dispatch(uploadAttackFileInvoice(bodyFormData, uploadType));
      }
    }
  };

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Upload biên bản đính kèm</Label>
        </ModalHeader>
        <ModalBody>
          <UploadForm
            multiple={true}
            handleFiles={files => handleFiles(files)}
            accept=".doc,.docx,.pdf"
            removeFile={(a, index) => {
              listFile.splice(index, 1);
              setListFile(listFile);
            }}
          ></UploadForm>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={listFile.length === 0}
            onClick={() => {
              dispatch(
                uploadFileInvoice(
                  idRootInvoice,
                  listFile.map(item => item.id)
                )
              );
            }}
          >
            <i className="bx bx-save label-icon" />
            Lưu biên bản đính kèm
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

UploadFileAttack.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  importHandle: PropTypes.any,
  idRootInvoice: PropTypes.any,
};

export default UploadFileAttack;
